export const createGetNextPageParam = (pageSize = 20) => (lastPage, pages) => {
    if (lastPage.length < (pageSize ? Number(pageSize) : 20)) {
        return;
    }
    return pages.length + 1;
};
//# sourceMappingURL=pagination.js.map